<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells position="between">
        <h1 class="title">{{ free_day_data.name }} ({{ free_day_data.clients.length }}) ID: {{ $route.params.id }}</h1>
        <app-button
          v-if="is_show_edit"
          @click.native="onShowDeleteModal('group', $route.params.id)"
          theme="error"
        >
          Delete
        </app-button>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <button v-if="is_show_edit" class="info-cards__control" @click="onShowEditGroupModal">
            <img src="@/assets/img/edit-table-icon.svg" alt="">
          </button>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Dates:</span><span>{{ dateFormat(free_day_data.tour_start) }} - {{ dateFormat(free_day_data.tour_end) }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Location:</span><span>{{ free_day_data.location.short_name }}</span>
            </div>
          </div>
        </div>
      </div>
      <app-cells>
        <app-textarea
          v-model="free_day_data.notes"
          rows="5"
          @change.native="onUpdateNotes"
          placeholder="Write a notes"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__full_name><div class="table-default__left">Name</div></template>
        <template #h__group><div class="table-default__left">Group</div></template>
        <template #full_name="{ row }">
          <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.citizenship ? row.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.citizenship ? row.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
            <template v-if="row.gender">
              <img v-if="row.gender?.code || null === 'male'" src="@/assets/img/male-icon.svg" alt="">
              <img v-if="row.gender?.code || null === 'female'" src="@/assets/img/female-icon.svg" alt="">
            </template>
            <img v-else src="@/assets/img/gender-plug-icon.svg" alt="">
            <router-link
              :to="{ name: 'clients-detail', params: { id: row.id } }"
              class="table-default__link-border"
            >
              {{ row.full_name }}
            </router-link>
            <span v-if="row.age">({{ row.age }} y.o.)</span>
            <img v-if="row.category && row.category.code === 'tour_leader'" src="@/assets/img/tour-leader-icon.svg" alt="Leader">
            <img v-if="row.birthday" src="@/assets/img/birthday-icon.svg" alt="Birthday">
          </div>
        </template>
        <template #group="{ row }">
          <div class="table-default__left">
            <div class="table-default__controls" v-if="row.group && row.group.id">
              <router-link
                :to="{name: 'clients-groups-general', params: {id: row.group.id }}"
                class="table-default__link-border"
              >
                {{ row.group.name }}
              </router-link>
            </div>
            <span v-else>-</span>
          </div>
        </template>
        <template #created_by="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.created_by.crop.crop_url)"
                alt="Avatar"
                v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10 }"
              >
            </div>
          </div>
        </template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button @click="onShowDeleteModal('client', row.id)" type="button">
              <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells><h2 class="title">Hotels</h2></app-cells>
      <template v-if="reservations.length">
        <div v-for="(reservation, index) in reservations" :key="`reservations_${index}`">
          <AppAccHotel :reservation="reservation" :order-number="index + 1" />
        </div>
      </template>
      <div v-else class="no-results no-results--margin">
        <img src="@/assets/img/schedule-plug-icon.svg" alt="">
        <div class="no-results__title">No Results</div>
        <div class="no-results__text">There’s no reservations yet</div>
      </div>
    </template>
    <modal
      name="delete-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete {{ modal_type === 'client' ? 'client' : 'group' }}
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this {{ modal_type === 'client' ? 'client' : 'group' }}?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteItem" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="edit-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('edit-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Edit free day</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckFreeForm">
            <app-form-group label="Group name" label-for="group_name_free" required>
              <app-input
                v-model="free_form.name"
                :error="$v.free_form.name.$error"
                id="group_name_free"
                placeholder="Group name"
                name="group_name_free"
              />
              <template #error>
                <div v-if="$v.free_form.name.$dirty && !$v.free_form.name.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Location" required>
              <app-select
                @input="onFreeLocationSelected"
                @search="onLocationSearch"
                v-model="free_form.location"
                :options="location_options"
                :clearable="false"
                placeholder="Location"
                :error="$v.free_form.location.$error"
              />
              <template #error>
                <div v-if="$v.free_form.location.$dirty && !$v.free_form.location.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="From" required>
              <app-date-picker
                v-model="free_form.tour_start"
                placeholder="From"
                :error="$v.free_form.tour_start.$error"
              />
              <template #error>
                <div v-if="$v.free_form.tour_start.$dirty && !$v.free_form.tour_start.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="To" required>
              <app-date-picker
                v-model="free_form.tour_end"
                placeholder="To"
                :error="$v.free_form.tour_end.$error"
              />
              <template #error>
                <div v-if="$v.free_form.tour_end.$dirty && !$v.free_form.tour_end.required">Required field</div>
              </template>
            </app-form-group>
<!--            <app-form-group label="Notes" label-for="notes_free">-->
<!--              <app-textarea-->
<!--                v-model="free_form.notes"-->
<!--                id="notes_free"-->
<!--                placeholder="Notes"-->
<!--              />-->
<!--            </app-form-group>-->
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="free_submit" :disabled="$v.free_form.$error">Save</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteClientsFreeDay,
  deleteClientsFreeDayClient,
  getClientsFreeDay,
  getClientsFreeDayClients,
  getGoogleSearch,
  getReservationsHotelsList,
  patchClientsFreeDay,
  postLocation,
} from '@/http'
import { format, parse } from 'date-fns'
import { required } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'
import AppAccHotel from '@/components/AppAccHotel.vue'

export default {
  name: 'FreeDaysDetail',
  components: { AppAccHotel },
  data() {
    return {
      is_loaded: false,
      free_day_data: {},
      table: {
        items: [],
        columns: ['full_name', 'group', 'created_by', 'controls'],
        options: {
          headings: {
            full_name: 'Name',
            date: 'Group',
            created_by: 'Manager',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      modal_type: '',
      item_to_delete: null,
      free_form: {},
      location_options: [],
      reservations: []
    }
  },
  validations: {
    free_form: {
      name: { required },
      tour_start: { required },
      tour_end: { required },
      location: { required },
    },
  },
  computed: {
    is_show_edit() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('sales_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
  },
  created() {
    getClientsFreeDay(this.$route.params.id)
      .then(response => {
        this.free_day_data = response.data
        document.title = `${this.free_day_data.name} (${this.free_day_data.clients.length}) ID: ${ this.$route.params.id } | Altezza Board`
        this.is_loaded = true
      })
    this.fetchClients()
    getReservationsHotelsList({ freeday: this.$route.params.id, sales_status_exclude: 'cancel' })
      .then(res => {
        this.reservations = res.data
      })
  },
  methods: {
    getFreeData() {
      getClientsFreeDay(this.$route.params.id)
        .then(response => {
          this.free_day_data = response.data
        })
    },
    onFreeLocationSelected({ name, place_id }) {
      postLocation({ name, place_id }).then(res => {
        this.free_form.location = res.data
      })
    },
    onShowEditGroupModal() {
      this.free_form = {
        location: this.free_day_data.location,
        tour_start: this.free_day_data.tour_start,
        tour_end: this.free_day_data.tour_end,
        name: this.free_day_data.name,
      }
      this.$modal.show('edit-modal')
    },
    onCheckFreeForm() {
      this.$v.free_form.$touch()
      if (this.$v.free_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendFreeForm()
      }
    },
    sendFreeForm() {
      this.$refs.free_submit.preload = true
      patchClientsFreeDay(this.$route.params.id, {...this.free_form, location: this.free_form.location.id})
        .then(() => {
          this.getFreeData()
          this.$notify({
            type: 'success',
            title: 'Group edited',
          })
          this.$modal.hide('edit-modal')
        })
        .catch(() => {
          this.$refs.free_submit.preload = false
        })
    },
    fetchClients() {
      getClientsFreeDayClients(this.$route.params.id)
        .then(response => {
          this.table.items = response.data
        })
    },
    onShowDeleteModal(type, id) {
      this.modal_type = type
      this.item_to_delete = id
      this.$modal.show('delete-modal')
    },
    onDeleteItem() {
      this.$refs.delete.preload = true
      if (this.modal_type === 'client') {
        deleteClientsFreeDayClient(this.$route.params.id, this.item_to_delete)
          .then(() => {
            this.fetchClients()
            this.$modal.hide('delete-modal')
            this.$notify({
              type: 'success',
              title: 'Client deleted',
            })
          })
          .catch(() => {
            this.$refs.delete.preload = false
          })
      } else {
        deleteClientsFreeDay(this.item_to_delete)
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Group deleted',
            })
            this.$router.push({name: 'free-days-list'})
          })
          .catch(() => {
            this.$refs.delete.preload = false
          })
      }
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    onUpdateNotes() {
      patchClientsFreeDay(this.$route.params.id, { notes: this.free_day_data.notes })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Notes saved',
          })
        })
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          vm.location_options = response.data
          loading(false)
        })
      }
    }, 350),
  }
}
</script>
